import { useAddressStyling } from '../../hooks';

const Address = () => {
  useAddressStyling();

  return <></>;
};

export default Address;
